<div
  class="field iss-form-field"
  [class.iss-form-field--no-necessity]="!showNecessity"
  [class.iss-form-field--required]="required"
  [class.iss-form-field--optional]="!required"
>
  <ng-container *ngIf="label">
    <ng-content select="iss-label,[issLabel]"/>
  </ng-container>
  <ng-content/>
  <div *ngIf="hintVisible && hint" class="help iss-form-field-hint">
    {{ hint }}
  </div>
  <div *ngIf="errorVisible" class="help is-danger">
    <ng-container
      [ngTemplateOutlet]="formFieldErrorDirective!.templateRef"
      [ngTemplateOutletContext]="{ $implicit: errors, errorsByFields: errorsByFields }"
    />
  </div>
</div>
